$(function() {
	$('a[data-id="getStarted"]').on('click',
		function () {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				"event": "engagement",
				"category": "evergreen-getStarted"
			});
		});

	$('a[data-id="rsvp"]').on('click',
		function () {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				"event": "engagement",
				"category": "evergreen-rsvp"
			});
		});

	$('button[data-id="submit"]').on('click',
		function () {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				"event": "engagement",
				"category": "evergreen-submit"
			});
		});

	$('a[data-id="createNewCard"]').on('click',
		function () {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				"event": "engagement",
				"category": "evergreen-createNewCard"
			});
		});

	$('input:checkbox[data-id="sendAsGift"]').change(
		function () {
			if ($(this).prop('checked')) {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					"event": "engagement",
					"category": "evergreen-sendasgift"
				});
			}
		});
});
